// extracted by mini-css-extract-plugin
export var alt = "InfoIconTooltip-module--alt--61740";
export var desktopOnly = "InfoIconTooltip-module--desktopOnly--24798";
export var infoIcon = "InfoIconTooltip-module--infoIcon--2cfb6";
export var main = "InfoIconTooltip-module--main--06b4c";
export var mobileOnly = "InfoIconTooltip-module--mobileOnly--973c4";
export var textLeft = "InfoIconTooltip-module--textLeft--2661d";
export var visuallyHidden = "InfoIconTooltip-module--visuallyHidden--b7b68";